


































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import Utils from '@/utils'
import {AvailabilityResponse, ReservationResponse, UserMesh, VehicleSlot} from '@/lib/kepler/interfaces'
import {PopupState} from '@/store'
import {ProfileState} from '@/store/modules/profile'
import Card from '@/components/proxy/Card/Card.vue'
import sdk from '@/lib/kepler/sdk'
import ProgressCircular from '@/components/proxy/ProgressCircular.vue'
import LoginView from '../views/Login.vue'
import QuickRegistrationView from '@/views/Flows/FlowQuickRegistration.vue'
import Container from '@/components/proxy/Container.vue'
import ServiceMesh from '@/lib/serviceMesh'

@Component({
  components: {
    Container,
    ProgressCircular,
    Card,
    Button: Utils.loadComponent('Button'),
    Layout: Utils.loadComponent('proxy/Layout'),

  },
  name: 'BookingButtons',
})

export default class BookingButtons extends Vue {
  // TODO: clean up imports and dependencies
  @State('profile') public profileState!: ProfileState
  @State((state) => state.profile.userMesh) public userMesh!: UserMesh[]
  @State((state) => state.configuration.appConfig.fields_configuration) public fieldConfigState!: any
  @State((state) => state.configuration.appConfig.time_slot_dimension) public timeSlot!: any
  @Action('openPopup') public openPopup: any
  @Action('closePopup') public closePopup: any
  @Action('setZone') public setZone!: (id: string) => Promise<void>
  @Action('openDialog') public openDialog: any
  @Action('closeDialog') public closeDialog: any
  @Action('cleanVehicleSlot') public cleanVehicleSlot: any
  @Action('vehicleAvailability') public vehicleAvailability: any
  @Action('bookEstimate') public bookEstimate: any
  @Action('getUserMesh') public getUserMesh: any
  @Action('getSubscriptions') public getSubscriptions: any

  @Prop() public vehicleSlot!: VehicleSlot
  @Prop() public currentTab!: number
  @Prop() public loadingProp!: boolean

  public loading: boolean = true
  public reservation?: ReservationResponse
  public availability: AvailabilityResponse[] = []
  public canBook: boolean = false
  public isMainDriver: boolean = false

  protected get isLogged() {
    return sdk.people.isLogged()
  }

  protected get vehicleTypeColor() {
    const key = `${this.vehicleSlot.reservation_type}${this.vehicleSlot.vehicle.category.type}`.toUpperCase()
    return ServiceMesh.colors[key]
  }

  public mounted() {
    this.isMainDriver = this.profileState.driver && this.profileState.driver.main_driver || false

    if (this.userMesh.length === 0) {
      this.getUserMesh().then(() => {
        this.mounted()
      })
    }

    const checkIfCanBook = () => {
      const vehicleInMesh = this.userMesh.find((usermesh: UserMesh) => {
        const rType = usermesh.booking_mode.toLowerCase() === this.vehicleSlot.reservation_type.toLowerCase()
        const vType = usermesh.vehicle_type.toLowerCase() === this.vehicleSlot.vehicle.category.type.toLowerCase()
        return rType && vType
      })
      this.canBook = vehicleInMesh ? vehicleInMesh.available : false
      this.loading = false
    }

    if (this.isMainDriver) {
      this.getSubscriptions().then(checkIfCanBook())
    } else {
      checkIfCanBook()
    }
  }

  protected goToPlans() {
    this.closePopup()
    this.$router.push({name: 'plans'})
  }

  protected login() {
    this.closeDialog(0)
    this.openPopup(new PopupState(LoginView, null, 'Login', false))
  }

  protected signUp() {
    this.closeDialog(0)
    this.openPopup(new PopupState(QuickRegistrationView, null, null, true))
  }
}
